export default __webpack_public_path__ + "static/media/features-mock-slide2-strike@2x.40696e38.png";